import React from "react";
import { AYLAR, formatTL } from "@/lib/api";

const addMonth = (y, m, k) => { const t = y * 12 + (m - 1) + k; return { yil: Math.floor(t / 12), ay: (t % 12) + 1 }; };

export const buildPlan = (toplam, taksit, yil, ay, yuvarla, kaynak = "maas") => {
  const T = Number(toplam) || 0;
  const n = Math.max(1, Number(taksit) || 1);
  const base = yuvarla ? Math.floor(T / n) : Math.floor((T / n) * 100) / 100;
  return Array.from({ length: n }, (_, k) => ({
    ...addMonth(Number(yil), Number(ay), k),
    tutar: k === n - 1 ? Math.round((T - base * (n - 1)) * 100) / 100 : base,
    kaynak,
  }));
};

export const planSum = (plan) => Math.round(plan.reduce((s, i) => s + (Number(i.tutar) || 0), 0) * 100) / 100;

export const AdvancePlanTable = ({ plan, setPlan, toplam }) => {
  const set = (k, f, v) => setPlan(plan.map((i, j) => (j === k ? { ...i, [f]: v } : i)));
  const sum = planSum(plan);
  const diff = Math.round(((Number(toplam) || 0) - sum) * 100) / 100;
  const last = plan[plan.length - 1];
  const sums = plan.reduce((a, i) => ({ ...a, [i.kaynak]: (a[i.kaynak] || 0) + (Number(i.tutar) || 0) }), {});
  return (
    <div className="border border-slate-200 rounded-lg overflow-hidden" data-testid="advance-plan-table">
      <div className="max-h-64 overflow-y-auto">
        <table className="w-full text-xs">
          <thead className="bg-slate-50 sticky top-0"><tr><th className="text-left px-2 py-1.5">Ay</th><th className="text-right px-2 py-1.5">Kesinti (₺)</th><th className="px-2 py-1.5">Kaynak</th><th /></tr></thead>
          <tbody>
            {plan.map((i, k) => (
              <tr key={k} className="border-t border-slate-100" data-testid={`plan-row-${k}`}>
                <td className="px-2 py-1 font-semibold">{AYLAR[i.ay - 1]?.n} {i.yil}</td>
                <td className="px-2 py-1"><input type="number" min="0" step="0.01" value={i.tutar} data-testid={`plan-tutar-${k}`}
                  onChange={(e) => set(k, "tutar", e.target.value)} className="w-28 ml-auto block px-2 py-1 border border-slate-200 rounded text-right font-mono-tab" /></td>
                <td className="px-2 py-1 text-center">
                  <div className="inline-flex rounded border border-slate-200 overflow-hidden">
                    {[["maas", "Maaştan"], ["prim", "Primden"]].map(([v, l]) => (
                      <button key={v} type="button" onClick={() => set(k, "kaynak", v)} data-testid={`plan-kaynak-${k}-${v}`}
                        className={`px-2 py-0.5 text-[11px] font-semibold ${i.kaynak === v ? (v === "prim" ? "bg-emerald-600 text-white" : "bg-slate-900 text-white") : "bg-white text-slate-500"}`}>{l}</button>
                    ))}
                  </div>
                </td>
                <td className="px-1">{plan.length > 1 && <button type="button" onClick={() => setPlan(plan.filter((_, j) => j !== k))} className="text-slate-400 hover:text-rose-600 text-sm">×</button>}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="flex items-center justify-between gap-2 px-2 py-1.5 bg-slate-50 border-t border-slate-200 text-[11px] flex-wrap">
        <button type="button" data-testid="plan-add-month" onClick={() => setPlan([...plan, { ...addMonth(last.yil, last.ay, 1), tutar: Math.max(0, diff), kaynak: last.kaynak }])}
          className="font-semibold text-slate-700 hover:underline">+ Ay ekle</button>
        <span className="text-slate-600">Maaştan {formatTL(sums.maas || 0)} · Primden {formatTL(sums.prim || 0)}</span>
        <span className={`font-bold ${diff ? "text-rose-700" : "text-emerald-700"}`} data-testid="plan-diff">
          {diff ? `Fark ${formatTL(diff)} · toplam avansa eşit olmalı` : "Toplam eşit ✓"}
        </span>
      </div>
      <div className="px-2 pb-1.5 bg-slate-50 text-[10px] text-slate-500">Primden seçilen taksit o ay prim yetmezse kalan sonraki aya devreder.</div>
    </div>
  );
};
